import {getServerTexts as getTexts, initTexts, texts} from '../../Localization/texts';

const entity = 'UI_MULTICOMPANY';

const en = {
    search: 'Search',
    selectAll: 'Select All',
    selectedNum: 'XXX Selected',
    ok: 'OK',
    noResults: `We didn’t find any results.\n\nDouble-check your spelling and try again.`,
    multiSelectTitle: 'Define multiple companies'
};

const he = {
    search: 'חיפוש',
    selectAll: 'בחירת כל החברות',
    selectedNum: 'נבחרו XXX חברות',
    ok: 'אישור',
    noResults: `לא מצאנו תוצאות.\n\nכדאי לבדוק את האיות ולנסות שוב.`,
    multiSelectTitle: 'בחירת חברות לסביבה'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'multiSelectTitle',
    2: 'search',
    3: 'selectAll',
    4: 'selectedNum',
    5: 'ok',
    6: 'noResults'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks accoring to the user's locale
initTexts(entity, fallbacks);

// export entity texts
// usage: import texts from './texts'
export default texts[entity];
